import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["backdrop", "container", "customHours", "customDays", "error"];
  static values = { notificationId: Number };

  connect() {
    try {
      console.debug("[SnoozeModal] connect", {
        hasContainerTarget: this.hasContainerTarget,
        hasCustomHoursTarget: this.hasCustomHoursTarget,
        hasCustomDaysTarget: this.hasCustomDaysTarget
      });
    } catch (_) {}
  }

  open(event) {
    event.preventDefault();
    const id = (event.params && event.params.notificationId) || (event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.notificationId);
    if (!id) {
      console.warn("[SnoozeModal] open called without notificationId param");
      return;
    }
    this.notificationIdValue = parseInt(id, 10);
    if (this.hasContainerTarget) {
      console.debug("[SnoozeModal] opening modal", { notificationId: this.notificationIdValue, container: this.containerTarget });
      this.containerTarget.classList.remove("hidden");
      // Match global modal behavior
      document.body.classList.add("modal-open");
      requestAnimationFrame(() => {
        this.containerTarget.classList.add("modal--visible");
      });
    }
  }

  close(event) {
    if (event) event.preventDefault();
    if (this.hasContainerTarget) {
      console.debug("[SnoozeModal] closing modal");
      this.containerTarget.classList.remove("modal--visible");
      setTimeout(() => {
        this.containerTarget.classList.add("hidden");
        document.body.classList.remove("modal-open");
      }, 200);
    }
    if (this.hasErrorTarget) this.errorTarget.textContent = "";
  }

  async snoozeHours(event) {
    event.preventDefault();
    const hours = parseInt(event.params.hours, 10) || 1;
    console.debug("[SnoozeModal] snoozeHours", { hours, notificationId: this.notificationIdValue });
    await this.submit({ snooze_hours: hours });
  }

  async snoozeDays(event) {
    event.preventDefault();
    const days = parseInt(event.params.days, 10) || 1;
    console.debug("[SnoozeModal] snoozeDays", { days, notificationId: this.notificationIdValue });
    await this.submit({ snooze_days: days });
  }

  async snoozeCustom(event) {
    event.preventDefault();
    const hours = this.hasCustomHoursTarget ? parseInt(this.customHoursTarget.value || "0", 10) : 0;
    const days = this.hasCustomDaysTarget ? parseInt(this.customDaysTarget.value || "0", 10) : 0;
    if (!hours && !days) {
      if (this.hasErrorTarget) this.errorTarget.textContent = "Enter hours or days";
      console.warn("[SnoozeModal] snoozeCustom without values");
      return;
    }
    console.debug("[SnoozeModal] snoozeCustom", { hours, days, notificationId: this.notificationIdValue });
    await this.submit({ ...(hours ? { snooze_hours: hours } : {}), ...(days ? { snooze_days: days } : {}) });
  }

  async submit(body) {
    try {
      const id = this.notificationIdValue;
      if (!id) {
        console.error("[SnoozeModal] submit without notificationId");
        return;
      }
      const tokenMeta = document.querySelector('meta[name="csrf-token"]');
      const token = tokenMeta && tokenMeta.content;
      if (!token) console.warn("[SnoozeModal] CSRF token meta not found");
      console.debug("[SnoozeModal] submit payload", { id, body });
      const resp = await fetch(`/notifications/${id}/snooze`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
        body: JSON.stringify(body)
      });
      if (!resp.ok) {
        const text = await resp.text();
        console.error("[SnoozeModal] request failed", { status: resp.status, body: text });
        throw new Error("Request failed");
      }
      let data = {};
      try { data = await resp.json(); } catch (_) {}
      console.debug("[SnoozeModal] snoozed successfully", data);
      this.close();
      // Optionally refresh the page or update the card state
      // For now, do a light refresh of the list area if available
      try { window.location.reload(); } catch(_) {}
    } catch (e) {
      console.error("[SnoozeModal] submit error", e);
      if (this.hasErrorTarget) this.errorTarget.textContent = "Failed to snooze. Please try again.";
    }
  }
}


